import { StatisticsData, StatisticsDataQuery } from '@dreryk/egabinet-statistics-frontend-api';

import { useCqrsFind, UseCqrsQueryResult } from '@dreryk/command-query-react-common';

export const useFindStatisticsData: (statisticsId: number) => UseCqrsQueryResult<StatisticsData | null> = (
   statisticsId
) => {
   return useCqrsFind<StatisticsData | null>(
      () => {
         const query = new StatisticsDataQuery();
         query.id = statisticsId;
         return query;
      },
      { cacheTime: 'long' }
   );
};
